import { NotificationResponse } from '@common/entities';
import { get, patch } from 'config/api/config';

const NOTIFICATIONS_ENDPOINT = '/viewer/notifications-application';
const USER_NOTIFICATIONS_ENDPOINT = '/viewer/notifications-user';
const MARK_READ_ENDPOINT = '/viewer/notifications';

export interface GetNotificationsParams {
  applicationResponseId: string;
  unreadOnly?: boolean;
  type?: string;
}

export interface GetUserNotificationsParams {
  userId: number;
  unreadOnly?: boolean;
  type?: string;
}

export const getNotificationsForApplication = async (params: GetNotificationsParams) => {
  const { applicationResponseId, unreadOnly, type } = params;

  const queryParams = new URLSearchParams();
  queryParams.append('applicationResponseId', applicationResponseId);

  if (unreadOnly !== undefined) queryParams.append('unreadOnly', unreadOnly.toString());
  if (type !== undefined) queryParams.append('type', type);

  const response = await get<NotificationResponse>(
    `${NOTIFICATIONS_ENDPOINT}?${queryParams.toString()}`,
  );
  return response?.data;
};

export const getNotificationsForUser = async (params: GetUserNotificationsParams) => {
  const { userId, unreadOnly, type } = params;

  const queryParams = new URLSearchParams();
  queryParams.append('userId', userId.toString());

  if (unreadOnly !== undefined) queryParams.append('unreadOnly', unreadOnly.toString());
  if (type !== undefined) queryParams.append('type', type);

  const endpoint = `${USER_NOTIFICATIONS_ENDPOINT}?${queryParams.toString()}`;

  const response = await get<NotificationResponse>(endpoint);
  return response?.data;
};

export const markNotificationAsRead = async (ids: string[]): Promise<void> => {
  await patch(`${MARK_READ_ENDPOINT}/read`, { ids });
};
